export async function getCountriesList() {
  try {
    const response = await fetch("/iso-3166-2.json");
    if (!response.ok) {
      throw new Error(`Failed to fetch countries: ${response.status}`);
    }
    const isoData = await response.json();
    return Object.entries(isoData).map(([code, details]) => ({
      code,
      label: details.name
    }));
  } catch (error) {
    console.error("Error fetching countries:", error);
    return []; // Return empty array on error
  }
}

export async function getStatesList(countryCodes) {
  // Handle both single string and array inputs
  const codeArray = Array.isArray(countryCodes) ? countryCodes : [countryCodes];

  const response = await fetch("/iso-3166-2.json");
  const isoData = await response.json();

  const results = [];

  for (const countryCode of codeArray) {
    const country = isoData[countryCode];

    // Skip if country doesn't exist or has no divisions
    if (!country || !country.divisions) continue;

    // Add all states from this country to the results array
    const states = Object.entries(country.divisions).map(([code, name]) => ({
      code,
      label: name,
      countryCode // Include the parent country code for reference
    }));

    results.push(...states);
  }

  return results;
}
